import { Component, OnInit, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { NgbAlert } from '@ng-bootstrap/ng-bootstrap';

import { defaultData, dismissingData } from './data';
import { AlertColor } from './alerts.model';
import { EventService } from 'src/app/core/services/event.service';

@Component({
  selector: 'app-alerts',
  templateUrl: './alerts.component.html',
  styleUrls: ['./alerts.component.scss']
})
export class AlertsComponent implements OnInit {

  // bread crumb items
  breadCrumbItems!: Array<{}>;
  defaultData: AlertColor[] = [];
  dismissingData: AlertColor[] = [];
  alertData: AlertColor[] = [];
  staticAlertClosed = false;
  alert: any;
  @ViewChild('staticAlert', { static: false })
  staticAlert!: NgbAlert;
  @ViewChild('selfClosingAlert', { static: false })
  selfClosingAlert!: NgbAlert;
  time = 0;

  constructor(private eventService: EventService) { }

  ngOnInit(): void {
    // Alert Message Append
    this.eventService.subscribe('alert', alert => {

      if (alert.type === 'closed') {
        if (this.selfClosingAlert) {
          this.selfClosingAlert.close();
        }
      } else {
        this.alert = {};
        this.alert.message = alert.message
        this.alert.type = this.defaultData.find(al => al.color === alert.type);
        this.time = alert?.time ? alert.time : this.time;

        if (this.time > 0) {
          setTimeout(() => {
            if (this.selfClosingAlert) {
              this.selfClosingAlert.close();
            }
          }, this.time);
        }
      }
    });
    /***
     * Data Get
    */
    this._fetchData();
  }

  /***
  * Data Get
  */
  private _fetchData() {
    this.defaultData = defaultData;
    this.dismissingData = dismissingData;
  }

}
